module.exports = __webpack_public_path__ + "img/game_glotto.73724be.webp";